import React from 'react'; 
import { I2cIconButton } from '@webcomponents/i2cwebcomponents/dist/react';

const AppSelectionIcons = ({ appSelectionForProgram, mobileLink, webLink }) => {
  const hasMobileApp = appSelectionForProgram.includes("Android App") || appSelectionForProgram.includes("iOS App");
  const hasWebApp = appSelectionForProgram.includes("C-Holder Website");
  const hasAll = appSelectionForProgram.includes("C-Holder Website") && appSelectionForProgram.includes("Android App") && appSelectionForProgram.includes("iOS App");

  if (hasAll) {
    return (
      <>
        {/* Render the two icons with I2cIconButton when all three values are present */}
        <I2cIconButton
          name="linear-mobile"
          label="Mobile App"
          href={mobileLink}
          target="_blank"
        >
        </I2cIconButton>
        <I2cIconButton
          name="linear-monitor"
          label="Web App"
          href={webLink}
          target="_blank"
        > 
        </I2cIconButton>
      </>
    );
  }

  return (
    <>
      {hasMobileApp && (
        <I2cIconButton
          name="linear-mobile"
          label="Mobile App"
          href={mobileLink}
          target="_blank"
        >
        </I2cIconButton>
      )}
      {hasWebApp && (
        <I2cIconButton
          name="linear-monitor"
          label="Web App"
          href={webLink}
          target="_blank"
        >
        </I2cIconButton>
      )}
    </>
  );
};

export default AppSelectionIcons;
